import { useFeatureFlagEnabled } from '@/features/flags/posthog-compat';

export const SESSION_HAND_OFF_FLAG_KEY = 'release-scribe-session-hand-off';

/**
 * Gates the session Hand off feature — the V2 Session card row, the
 * Cmd/Ctrl+Alt+F shortcut, and the hand off modal itself. The flag lives in
 * POSTHOG (already created there), not Flagsmith — percentage/cohort ramp is
 * configured in the PostHog dashboard. Default OFF.
 *
 * ROLLOUT DEPENDENCY: hand off creates a clinical task, so availability also
 * requires the clinical-tasks flag (folded into useIsHandOffAvailable) —
 * ramp this flag only inside the clinical-tasks cohort.
 */
export const useIsSessionHandOffEnabled = (): boolean =>
  useFeatureFlagEnabled(SESSION_HAND_OFF_FLAG_KEY) ?? false;
